import { useEffect, useState } from 'react';

export const fmtDate = (dt: string | null | undefined) =>
  dt ? new Date(dt).toLocaleDateString('nl-NL', { day: '2-digit', month: 'short', year: 'numeric' }) : '—';

export const fmtDateTime = (dt: string | null | undefined) =>
  dt ? new Date(dt).toLocaleString('nl-NL', { day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit' }) : '—';

export const fmtEur = (cents: number) =>
  new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(cents / 100);

export const fmtEurFromEur = (eur: number) =>
  new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(eur);

export const roleStyles: Record<string, string> = {
  superadmin: 'bg-black text-white dark:bg-white dark:text-black',
  beheerder: 'bg-accent/15 text-accent border border-accent/25 dark:bg-accent/25 dark:text-accent',
  medewerker: 'bg-black/5 text-ink/70 border border-black/10 dark:bg-white/10 dark:text-white/75 dark:border-white/15',
};

export const statusStyles = (status: string): string => {
  if (['paid', 'delivered', 'sent', 'activated'].includes(status))
    return 'bg-green-50 dark:bg-green-950 text-green-700 dark:text-green-300 border border-green-200 dark:border-green-900';
  if (['pending', 'queued'].includes(status))
    return 'bg-amber-50 dark:bg-amber-950 text-amber-700 dark:text-amber-300 border border-amber-200 dark:border-amber-900';
  if (['bounced', 'failed', 'revoked'].includes(status))
    return 'bg-red-50 dark:bg-red-950 text-red-700 dark:text-red-300 border border-red-200 dark:border-red-900';
  return 'bg-black/5 dark:bg-white/10 text-ink/60 dark:text-white/65 border border-black/10 dark:border-white/15';
};

/** Lightweight "fetch on mount" hook with manual refresh. */
export function useFetch<T>(loader: () => Promise<T>, deps: React.DependencyList = []) {
  const [data, setData] = useState<T | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [tick, setTick] = useState(0);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);
    loader()
      .then((d) => !cancelled && setData(d))
      .catch((e) => !cancelled && setError(e instanceof Error ? e.message : 'Laden mislukt'))
      .finally(() => !cancelled && setLoading(false));
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tick, ...deps]);

  return { data, loading, error, refresh: () => setTick((t) => t + 1) };
}
